import { render, staticRenderFns } from "./BtnInserirCronogramaDesembolso.vue?vue&type=template&id=4e34974a"
import script from "./BtnInserirCronogramaDesembolso.vue?vue&type=script&lang=js"
export * from "./BtnInserirCronogramaDesembolso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports